import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import "./PushButtonFilterMercadoShops.css";

const CustomButton = ({ messageId, quantity, onClick }: any) => {
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive(!isActive);
    onClick();
  };

  return (
    <div
      className={`push-btn-filter-ms ${isActive ? "active" : ""}`}
      onClick={handleClick}
    >
      <FormattedMessage id={messageId} defaultMessage={messageId}>
        {(text) => (
          <span>
            {text} ({quantity})
          </span>
        )}
      </FormattedMessage>
    </div>
  );
};

export default CustomButton;
